<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div style="overflow-x: auto">
      <table aria-label="Tableau affichant l'historique"
             class="table table-bordered table-striped table-border-purple table-head-purple">
        <thead class="thead-default">
        <tr>
          <th class="text-center" i18n="@@removalID" scope="col">Removal ID</th>
          <th class="text-center" i18n="@@quantity" scope="col">Quantity</th>
          <th class="text-center" i18n="@@animalSpecies" scope="col">Species</th>
          <th class="text-center" i18n="@@animalCategory" scope="col">Category</th>
          <th class="text-center" i18n="@@country" scope="col">Country</th>
          <th class="text-center" i18n="@@animalNumber" scope="col">Animal ID</th>
          <th class="text-center" i18n="@@collectedOn" scope="col">Collected on</th>
          <th class="text-center" i18n="@@earring" scope="col">Earring</th>
          <th class="text-center" i18n="@@passport" scope="col">Passport</th>
          <th class="text-center" i18n="@@download" scope="col">Download</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let d of data">
          <td class="text-center">{{ d?.removalId }}</td>
          <td class="text-center">{{ d?.quantity }}</td>
          <td class="text-center">{{ d?._embedded?.animalSpecies?.tag }}</td>
          <td class="text-center">{{ d?._embedded?.animalCategory?.tag }}</td>
          <td class="text-center">{{ d?._embedded?.country?.alpha2 }}</td>
          <td class="text-center">{{ d?.number }}</td>
          <td class="text-center">{{ formatDate(d?.dateCollection) }}</td>
          <td class="text-center">{{ d?.earring }}</td>
          <td class="text-center text-uppercase">
            <span *ngIf="true === d?.passport" i18n="@@yes">Yes</span>
            <span *ngIf="true !== d?.passport" i18n="@@no">No</span>
          </td>
          <td class="text-center">
            <button class="btn btn-link btn-icon-only btn-lg" (click)="print(d)">
              <em class="la la-file-text"></em>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
